import { render, staticRenderFns } from "./errCard.vue?vue&type=template&id=765d947f&scoped=true"
import script from "./errCard.vue?vue&type=script&lang=js"
export * from "./errCard.vue?vue&type=script&lang=js"
import style0 from "./errCard.vue?vue&type=style&index=0&id=765d947f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d947f",
  null
  
)

export default component.exports